<template>
    <div>
        <Breadcrumbs main="Admin" submain="Location" title="Country" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New Country</h7>
                            </button>
                        </div>
    
                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="country_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(name)="row">
                                            <div v-if="row.item.name">
                                                <p>{{ row.item.name }}</p>
                                            </div>
                                        </template>
    
                                        <template #cell(action)="data">
                                            <span style="display: flex; gap: 12px;">
                                                <div @click="editCountry(data.item)">
                                                    <feather type="edit" size="18px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                </div>
                                                <div>
                                                    <feather type="delete" size="18px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteCountry(data.item.id)" title="Delete"></feather>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    
        <!-- Country Create Modal -->
        <b-modal id="modal-prevent-closing" ref="modal" title="Add Country" size="md" @show="resetModal" @hidden="resetModal" @ok="handleOk">
            <form ref="form" @submit.stop.prevent="handleSubmit()">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Name</label>
                            <input class="form-control" type="text" placeholder="Enter country name" v-model="country.name">
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Country Edit Modal -->
        <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Country" size="md" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
            <form ref="form" @submit.stop.prevent="handleEditSubmit">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Name</label>
                            <input class="form-control" type="text" placeholder="Enter country name" v-model="edit_country.name">
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Country Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this country?</div>
        </b-modal>
    </div>
    </template>
    
<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import { mapState } from 'vuex';
    import { myHost } from '../../../_helpers/host';
    import loader from '../loader/loader.vue';
    
    export default {
        components: {
            loader
        },
    
        data() {
            return {
                host: myHost.host,
                tablefields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                    }
                ],
    
                country: {
                    name: ''
                },
    
                edit_country: {
                    id: '',
                    name: ''
                },
    
                delete_value: null,
    
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 15, 20]
            };
        },
    
        computed: {
            ...mapState({
                country_list: state => state.country.country,
                loading: state => state.country.countryLoading,
                error: state => state.country.countryError
            }),
    
            sortOptions() {
                // Create an options list from our fields
                return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
            }
        },
    
        mounted() {
            this.$store.dispatch("country/fetchCountry").then(() => {
                this.items = this.country_list
                this.totalRows = this.country_list.length;
            });
        },
    
        methods: {
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
    
            resetModal() {
                this.country.name = null
            },
    
            handleOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleSubmit()
            },
    
            handleSubmit() {
                this.$store.dispatch("country/addCountry", {
                    country: this.country
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.country.name = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing')
                })
            },
    
            editCountry(detail) {
                this.edit_country.id = detail.id ? detail.id : null
                this.edit_country.name = detail.name ? detail.name : null
            },
    
            resetEditModal() {
                this.edit_country.name = null
            },
    
            handleEditOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleEditSubmit()
            },
    
            handleEditSubmit() {
                this.$store.dispatch("country/updateCountry", {
                    id: this.edit_country.id,
                    country: this.edit_country
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.edit_country.name = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing-edit')
                })
            },
    
            deleteCountry(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("country/deleteCountry", {
                    delete: this.delete_value
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.delete_value = null
    
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
    </script>
    